import { createSelector } from '@reduxjs/toolkit';
import { partnersNotDeleted } from './partners-not-deleted';
import { contactsNotDeleted } from './contacts-not-deleted';
import { getOrganizationId } from '../organization/getOrganizationId';
import { currentPageId } from '../path';
import { entityNameForLists } from '../../../utilities/text';
import { sortBy } from 'lodash';
import type { ListSectionItemInput } from '../../../library/lists/listSectionItemInput';
import { trinnvisAsPartnerTemplateId } from 'src/store/selectors/partners/trinnvis-as-partner-template-id';

export const getPartnersAndContacts = createSelector(
  partnersNotDeleted,
  contactsNotDeleted,
  getOrganizationId,
  currentPageId,
  function (partners, contacts, organizationId, pageId): ListSectionItemInput[] {
    const partnersAndContacts: ListSectionItemInput[] = partners.map((p) => {
      const items: ListSectionItemInput[] = contacts
        .filter((c) => {
          return c.partnerUuid === p.uuid;
        })
        .map((c) => {
          let name = c.firstName;
          if (!name) {
            name = c.lastName;
          } else {
            name = c.firstName + ' ' + c.lastName;
          }
          return {
            label: entityNameForLists(name, c.draftName, c.isConfirmedEntity),
            href: '/account/' + organizationId + '/' + pageId + '/contacts/' + c.uuid,
            hasDraft: c.hasDraft,
            accessible: true,
          };
        });
      const result: ListSectionItemInput = {
        label: entityNameForLists(p.name, p.draftName, p.isConfirmedEntity),
        href: '/account/' + organizationId + '/' + pageId + '/partners/' + p.uuid,
        hasDraft: p.hasDraft,
        accessible: true,
        items: sortBy(items, ['label']),
      };
      if (p.unchangedTemplate && p.mainTemplateId && p.mainTemplateId !== trinnvisAsPartnerTemplateId) {
        result.mainIcon = 'suggestion';
        result.href += '?edit';
      }
      return result;
    });
    const sorted = sortBy(partnersAndContacts, ['label']);
    return sorted.filter((s) => s.mainIcon !== 'suggestion').concat(sorted.filter((s) => s.mainIcon === 'suggestion'));
  },
);
